import type { MemoTemplate } from '@/shared/templates/memos/lib/schema'

export interface MemoSection {
  uuid: string
  title: string
}

/**
 * The section a memo is filed in. A `select` template takes the picked one, a
 * `suggest` template whatever its picker shows and a pinned template its own.
 * Every other template follows the attached planning, then the section it is
 * written for, then the desk's own.
 */
export function fileSection({
  sectionChoice,
  pinned,
  chosenSection,
  suggestedSection,
  selectedPlanningSection,
  writtenForSection,
  fixedSection
}: {
  sectionChoice: MemoTemplate['sectionChoice']
  pinned: boolean
  chosenSection?: MemoSection
  suggestedSection?: MemoSection
  selectedPlanningSection?: MemoSection
  writtenForSection?: MemoSection
  fixedSection?: MemoSection
}): MemoSection | undefined {
  if (sectionChoice === 'select') {
    return chosenSection
  }

  if (sectionChoice === 'suggest') {
    return suggestedSection
  }

  if (pinned) {
    return fixedSection
  }

  return selectedPlanningSection ?? writtenForSection ?? fixedSection
}
